import { supabase } from "./supabaseClient";

export async function insertPing({ kind, note }) {
  const { data: u, error: uErr } = await supabase.auth.getUser();
  if (uErr) return { data: null, error: uErr };
  const uid = u?.user?.id;
  if (!uid) return { data: null, error: new Error("Not authenticated") };

  const payload = {
    sender_id: uid, // critical for RLS: must equal auth.uid()
    kind,
    note: (note || "").trim().slice(0, 240),
  };

  const { data, error } = await supabase
    .from("pings")
    .insert(payload)
    .select("id,sender_id,kind,note,created_at")
    .single();

  return { data, error };
}

export async function fetchLatestPings(limit = 100) {
  const { data, error } = await supabase
    .from("pings")
    .select("id,sender_id,kind,note,created_at")
    .order("created_at", { ascending: false })
    .limit(limit);

  return { data: data || [], error };
}
